import { Box, Stack } from "@mui/material";

interface ToggleOption<T extends string> {
  value: T;
  label: string;
}

interface ToggleButtonsProps<T extends string> {
  options: ToggleOption<T>[];
  value: T;
  onChange: (value: T) => void;
}

export function ToggleButtons<T extends string>({ options, value, onChange }: ToggleButtonsProps<T>) {
  return (
    <Stack
      direction="row"
      sx={{
        height: "32px",
        border: "1px solid #adbbc9",
        borderRadius: "20px",
        flexShrink: 0,
        overflow: "hidden"
      }}
    >
      {options.map((option, index) => {
        const isActive = option.value === value;
        const isLast = index === options.length - 1;
        return (
          <Box
            key={option.value}
            onClick={!isActive ? () => onChange(option.value) : undefined}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              px: "16px",
              cursor: !isActive ? "pointer" : "default",
              bgcolor: isActive ? "#071f35" : "white",
              color: isActive ? "white" : "#071f35",
              fontSize: "16px",
              fontWeight: 400,
              lineHeight: "24px",
              whiteSpace: "nowrap",
              userSelect: "none",
              ...(!isActive && !isLast ? { borderRight: "1px solid #7b92a9" } : {})
            }}
          >
            {option.label}
          </Box>
        );
      })}
    </Stack>
  );
}
